// extracted by mini-css-extract-plugin
module.exports = {"text":"SubPageHeader_text__1wLq9"};